// 刪除 indexedDB
export default function delete_db(db_name: string | string[]): Promise<void> {
  return new Promise((resolve, reject) => {
    // !self.db_version[db_name] && (self.db_version[db_name] = 1);
    (Array.isArray(db_name) ? Promise.all(db_name.map((name: string): Promise<unknown> => delete_db_request(name))) : delete_db_request(db_name))
      .then((result: any) => {
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });

  function delete_db_request(db_name: string) {
    return new Promise((resolve: (value: unknown) => void, reject) => {
      try {
        const DBRequest = indexedDB.deleteDatabase(db_name);

        DBRequest.onsuccess = (): void => {
          resolve(undefined);
        };
        DBRequest.onerror = (): void => {
          console.error('Error deleting database ' + db_name + '.');
          reject();
        };
      } catch (err) {
        console.error(`Error deleting database ${db_name}:`, err);
        reject();
      }
    });
  }
}
